import { UploadStatus } from "@/api/data";
import { Flex, Progress, Spin } from "antd";
import Container from "../ContentContainer/Container";

export default function ProgressBar({
  status,
  progress,
  uploadStatusTranslation,
}: {
  status: UploadStatus;
  progress: number;
  uploadStatusTranslation: Record<UploadStatus, string>;
}) {
  return (
    <Flex justify="center">
      <Container style={{ marginBottom: 16, maxWidth: 600 }}>
        <Flex
          gap={24}
          align="center"
          vertical
        >
          {status !== "failed" && status !== "success" && <Spin size="large" />}
          {uploadStatusTranslation[status]}
          <Progress
            percent={progress}
            status={status === "failed" ? "exception" : undefined}
          />
        </Flex>
      </Container>
    </Flex>
  );
}
